// Modules
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

// Guards
import { AuthGuard } from './Guard/auth.guard';

// Components
import { HomeComponent } from './Components/home/home.component';
import { CallbackComponent } from './core.component';
import { DashboardComponent } from './Components/dashboard/dashboard.component';
import { ExternalResourceComponent } from './Components/dashboard/external-resource/external-resource.component';
import { PushNotificationComponent } from './Components/dashboard/push-notification/push-notification.component';

// Routes
import { locationRoutes } from '../location/location.routes';
import { teamRoutes } from '../team/team.routes';
import { surveyRoutes } from '../survey/survey.routes';
import { CmsMenuComponent } from './Components/dashboard/cms-menu/cms-menu.component';

const routes: Routes = [
    { path: '', component: HomeComponent },
    { path: 'callback', component: CallbackComponent },
    { path: 'dashboard', component: DashboardComponent, canActivate: [AuthGuard], children: [
        { path: '', redirectTo: 'locations', pathMatch: 'full', data: { primary: false }},
        ...locationRoutes, ...teamRoutes, ...surveyRoutes,
        { path: 'cms', component: CmsMenuComponent, data: { title: 'CMS Menu', icon: 'list_alt', primary: true }},
        { path: 'resources', component: ExternalResourceComponent, data: { title: 'Resources', icon: 'library_books', primary: true }},
        { path: 'notification', component: PushNotificationComponent, data: { title: 'Notifications', icon: 'send', primary: true }}
    ]}
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule],
    providers: [AuthGuard]
})

export class RoutingModule {}